import _ from "lodash";
import request from "@/method/request";
import { data2_2 } from './data';
import { message } from "antd";
const rowNameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

export const compute = data => {
    const numConvert = (num = 0) => {
        num = Number(num || "0")
        return num
    }

    // 计算一
    const rowNum = [0, 1, 5, 6, 7, 9, 11, 13, 15, 17, 21, 24, 25, 26, 28, 29, 30, 31];
    const rowNextData = ['nextJan', 'nextFeb', 'nextMar'];
    for (let index = 0; index < rowNum.length; index++) {
        data[rowNum[index]].whole = rowNameData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0).toFixed(2);
        data[rowNum[index]].nextQ1 = rowNextData.reduce((a, b) => {
            a += numConvert(data[rowNum[index]][b]);
            return a
        }, 0).toFixed(2);
        (data[rowNum[index]].whole).toFixed(2);
        (data[rowNum[index]].nextQ1).toFixed(2);
    }
    // 计算二
    const nameData = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec', 'nextJan', 'nextFeb', 'nextMar', 'whole', 'nextQ1'];

    for (let index = 0; index < nameData.length; index++) {
        // 提前计算毛利润 GOP
        //  GOP
        data[22][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[21][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(4);
        //  盈亏平衡点/总费用
        data[23][nameData[index]] = (numConvert(data[8][nameData[index]]) - numConvert(data[21][nameData[index]])).toFixed(2);

        // 客房率
        data[2][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[1][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(4);
        // 平均房价
        data[3][nameData[index]] = (numConvert(data[1][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[1][nameData[index]])).toFixed(2);
        // 平均收入
        data[4][nameData[index]] = (numConvert(data[0][nameData[index]]) == 0 ? 0 : numConvert(data[5][nameData[index]]) / numConvert(data[0][nameData[index]])).toFixed(2);
        // 总收入
        data[8][nameData[index]] = (numConvert(data[7][nameData[index]]) + numConvert(data[6][nameData[index]]) + numConvert(data[5][nameData[index]])).toFixed(2);
        // 客房部门利润百分比
        data[10][nameData[index]] = (numConvert(data[5][nameData[index]]) == 0 ? 0 : numConvert(data[9][nameData[index]]) / numConvert(data[5][nameData[index]])).toFixed(4);
        // 餐饮部门利润百分比
        data[12][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[11][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(4);
        // 食品成本百分比
        data[14][nameData[index]] = (numConvert(data[6][nameData[index]]) == 0 ? 0 : numConvert(data[13][nameData[index]]) / numConvert(data[6][nameData[index]])).toFixed(4);
        // 人力资源成本
        data[16][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[15][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(4);
        // 能源成本
        data[18][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[17][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(4);
        // 其他费用成本
        data[19][nameData[index]] = (numConvert(data[23][nameData[index]]) - numConvert(data[17][nameData[index]]) - numConvert(data[15][nameData[index]]) - numConvert(data[13][nameData[index]])).toFixed(2);
        // 其他费用成本率
        data[20][nameData[index]] = (numConvert(data[8][nameData[index]]) == 0 ? 0 : numConvert(data[19][nameData[index]]) / numConvert(data[8][nameData[index]])).toFixed(4);
        // 总收费
        data[27][nameData[index]] = (numConvert(data[26][nameData[index]]) + numConvert(data[25][nameData[index]]) + numConvert(data[24][nameData[index]])).toFixed(2);
    }
    return data;
}

export const fillData = (data, b12) => {
    rowNameData.forEach(name => {
        data[0][name] = _.get(b12, `1.${name}`, 0);
        data[1][name] = _.get(b12, `2.${name}`, 0);
        data[2][name] = _.get(b12, `3.${name}`, 0);
        data[3][name] = _.get(b12, `4.${name}`, 0);
        data[4][name] = _.get(b12, `5.${name}`, 0);
        data[5][name] = _.get(b12, `7.${name}`, 0);
        data[6][name] = _.get(b12, `8.${name}`, 0);
        data[7][name] = _.get(b12, `9.${name}`, 0);
        data[8][name] = _.get(b12, `10.${name}`, 0);
        data[9][name] = _.get(b12, `32.${name}`, 0);
        data[10][name] = _.get(b12, `63.${name}`, 0);
        data[11][name] = _.get(b12, `33.${name}`, 0);
        data[12][name] = _.get(b12, `64.${name}`, 0);
        data[13][name] = _.get(b12, `12.${name}`, 0);
        data[14][name] = _.get(b12, `68.${name}`, 0);
        data[15][name] = _.get(b12, `74.${name}`, 0);
        data[16][name] = _.get(b12, `67.${name}`, 0);
        data[17][name] = _.get(b12, `48.${name}`, 0);
        data[18][name] = _.get(b12, `69.${name}`, 0);
        data[21][name] = _.get(b12, `55.${name}`, 0);
        data[24][name] = _.get(b12, `53.${name}`, 0);
        data[25][name] = _.get(b12, `54.${name}`, 0);
        data[26][name] = _.get(b12, `57.${name}`, 0);
    });
    return data
}

export const saveAllData = async (year) => {
    // 获取所有酒店 
    const { data: { hotels } } = await request('/getHotels');
    for (let i = 0; i < hotels.length; i++) {
        const item = hotels[i];
        //  获取当前酒店数据   
        const dataDefault = _.cloneDeep(data2_2);
        let data = dataDefault.filter((x, i) => i != 0);
        let dataSelect = dataDefault.filter((x, i) => i == 0);
        const { data: x, msg } = await request(`/_2_2_info?year=${year}&comid=${item.id}`);
        if (x.data && x.data.length > 0) {
            data = x.data.filter((x, i) => i != 0);
            dataSelect = x.data.filter((x, i) => i == 0);
        } else {
            data = fillData(data, msg);
        }
        data = compute(data);
        let dataFrom = new FormData();
        dataFrom.append('data', JSON.stringify([...dataSelect, ...data].map(x => ({ ...x, year, comid: item.id }))));
        let headres = {
            method: 'post',
            credentials: 'include',
            headers: {},
            body: dataFrom
        };
        await request('/add_2_2', headres);
    }
    message.success('保存成功！');
}


// WEBPACK FOOTER //
// ./src/components/table/2-Analysis/2-2/compute.js